export default {"src":"/_next/static/media/covered_loan_insurance_filled.f84c6d21.svg","height":60,"width":63,"blurWidth":0,"blurHeight":0};